import { action, payload } from 'ts-action'
import { IRegion as ILocation } from 'models/Region'
import { IError, IPayload } from 'models/Global'

export const GetLocations = action(
  'GetLocations',
  payload<IPayload<ILocation[]>>(),
)
export const GetLocationsErrors = action(
  'GetLocationsErrors',
  payload<IError>(),
)
export const LocationsFetching = action('LocationsFetching', payload<boolean>())
